var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4887.1699 1022.7983",
    height: 1022.7983,
    width: 4887.1699,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,-0.02656253,1023.9957)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.69863)",
    id: "g14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "#e10070",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15940.2,3790.96 c 99.4,0 185.3,34.91 255.1,104.7 69.8,69.82 104.7,155.74 104.7,255.08 0,96.66 -37.6,182.57 -107.4,252.39 -67.1,69.79 -150.3,104.7 -247,104.7 -99.3,0 -185.3,-32.22 -255,-102.04 -75.2,-67.13 -110.1,-153.04 -110.1,-255.07 0,-99.32 34.9,-185.24 104.7,-255.06 69.8,-69.79 153,-104.7 255,-104.7 z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    style: {
      fill: "#e10070",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11953.6,2134.22 -1591.7,5468.2 -2157.17,-0.04 v -351.13 l 205.23,-0.04 c 168.75,0.04 296.45,-13.63 383.09,-45.59 150.5,-45.58 246.29,-159.6 287.34,-337.46 22.77,-77.54 31.91,-246.28 31.91,-506.25 V 2052.15 c 0,-405.9 -9.14,-688.67 -36.48,-857.42 C 9039.34,975.82 8961.8,807.07 8834.1,697.621 8706.41,583.629 8555.9,524.34 8382.62,524.34 l -177.89,-0.039 V 164.02 l 2303.17,-0.04 v 360.321 l -146,-0.039 c -401.31,0.078 -661.28,196.168 -766.16,583.828 -36.48,141.36 -54.72,456.05 -54.72,944.06 V 6927.46 L 11502.1,164.02 h 342 l 1965.6,6763.44 V 1618.87 c 0,-250.82 -9.1,-456.06 -31.9,-615.67 -13.7,-132.259 -59.3,-237.149 -136.8,-310.11 -114,-109.5 -314.7,-168.75 -592.9,-168.75 l -91.2,-0.039 V 164.02 l 2795.7,-0.04 v 360.36 l -155.1,-0.039 c -383.1,0.039 -615.7,114.058 -697.8,346.64 -36.5,123.118 -59.2,373.979 -59.2,747.929 v 4528.71 c 0,250.82 13.6,460.62 31.9,624.8 18.2,127.7 63.8,232.62 136.8,305.59 114,113.98 310.1,173.28 588.3,173.28 l 155.1,-0.04 v 351.21 l -2175.5,-0.04 z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.25097)",
    id: "g20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "#e10070",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 14495.4,295.181 c -320.8,0 -550.5,145.822 -696.3,441.122 -164.1,339.047 -244.3,834.857 -244.3,1491.107 0,794.75 131.2,1327.03 397.4,1600.45 156.7,164.06 339,247.89 543.2,247.89 131.2,0 251.5,-32.81 360.9,-102.07 164.1,-102.08 288,-244.25 371.9,-433.82 134.9,-306.26 204.1,-751.01 204.1,-1337.97 0,-1272.361 -313.5,-1906.709 -936.9,-1906.709 z m 0,4068.579 c -557.8,0 -1009.9,-222.37 -1356.2,-659.84 -302.6,-382.83 -452.1,-889.57 -452.1,-1520.26 0,-627.08 149.5,-1133.81 452.1,-1520.269 342.7,-437.469 787.4,-656.21217 1330.7,-656.21217 572.3,0 1031.7,218.74317 1374.4,656.21217 302.6,386.459 455.7,896.849 455.7,1531.199 0,623.42 -153.1,1126.53 -455.7,1509.33 -342.7,437.47 -794.8,659.87 -1348.9,659.87 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.56881)",
    id: "g24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "#e10070",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 14904.6,281.889 c -125,0 -235.5,31.993 -331.4,98.846 -119.2,78.486 -209.3,186.051 -270.4,319.764 -119.1,252.923 -177.3,610.481 -177.3,1072.721 0,598.85 125,1014.55 375,1244.22 133.8,119.19 279.1,180.22 433.2,180.22 220.9,0 386.6,-116.25 497.1,-348.84 119.2,-249.99 177.3,-604.66 177.3,-1061.06 0,-1002.954 -235.5,-1505.871 -703.5,-1505.871 z m 125,3165.791 c -232.6,0 -436,-69.77 -613.4,-212.22 -93,-75.59 -171.5,-183.13 -232.5,-319.78 v 1979.73 l -1014.6,-49.43 v -218.04 l 52.3,-0.03 c 133.7,0.03 226.8,-29.03 276.2,-87.17 58.1,-61.06 84.3,-220.96 84.3,-479.67 V 808.064 c 0,-293.617 -8.7,-485.469 -29.1,-581.402 -2.9,-14.546 -14.5,-55.252 -37.8,-122.112 l 235.5,-0.025 c 52.3,87.251 101.8,162.818 148.3,226.79 52.3,75.567 98.8,110.453 139.5,110.453 34.9,0 75.6,-17.434 122.1,-55.226 119.2,-98.826 197.7,-159.88 235.5,-183.138 177.3,-113.3925 369.2,-171.5078 581.4,-171.5078 386.6,0 700.6,162.7678 939,482.5508 255.8,345.951 383.7,773.283 383.7,1287.853 0,534.89 -142.5,962.21 -427.3,1279.08 -221,244.22 -502.9,366.3 -843.1,366.3 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(2.18659)",
    id: "g28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path30",
    style: {
      fill: "#e10070",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 14961,1877.08 c 81.3,292.01 221.1,440.09 417.1,440.09 175.2,0 302.4,-118.88 383.8,-356.66 43.8,-135.58 66.7,-306.59 66.7,-513.09 l -919.8,-0.02 c 2.1,168.97 18.8,312.88 52.2,429.68 z m 965.7,-1464.177 c -118.9,-139.738 -264.9,-210.657 -442.2,-210.657 -225.3,0 -385.9,112.636 -477.6,335.796 -66.8,156.426 -100.2,400.473 -102.2,729.998 H 16300 c -10.4,277.42 -62.6,511.02 -156.4,698.74 -177.3,352.47 -440.1,529.76 -790.5,529.76 -235.7,0 -438,-93.85 -604.9,-281.57 -212.7,-237.78 -319.1,-554.8 -319.1,-951.09 0,-429.659 106.4,-759.205 319.1,-986.549 171,-181.4502 390.1,-273.22394 657,-273.22394 365,0 652.9,214.82294 867.7,644.48094 l -152.3,79.265 c -64.6,-133.5 -129.3,-239.865 -193.9,-314.95 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.91435)",
    id: "g32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "#e10070",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15983.2,338.214 c -47.7,54.785 -71.5,188.193 -71.5,400.222 V 4011.78 l -855.3,-40.51 v -178.69 l 66.7,-0.02 c 109.6,0.02 183.5,-23.79 224,-71.44 47.6,-52.42 71.4,-183.44 71.4,-395.47 V 738.436 c 0,-212.029 -23.8,-345.437 -71.4,-400.222 -40.5,-47.646 -114.4,-71.481 -224,-71.481 l -95.3,-0.017 V 85.6788 L 16300,85.6584 V 266.733 l -92.9,-0.017 c -107.2,0.017 -183.4,23.852 -223.9,71.498 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.74088)",
    id: "g36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path38",
    style: {
      fill: "#e10070",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15949,371.915 c -52.4,57.619 -76,204.343 -76,440.103 V 3088.57 l -940.5,-44.54 v -199.1 l 73.3,-0.02 c 120.6,0.02 201.8,-26.19 246.3,-75.95 52.4,-57.65 78.6,-204.35 78.6,-434.88 V 812.018 c 0,-233.157 -26.2,-379.858 -78.6,-440.103 -44.5,-52.393 -125.7,-78.581 -246.3,-78.581 l -104.7,-0.041 V 94.2162 L 16300,94.1938 V 293.334 l -102.2,-0.041 c -120.5,0.041 -204.3,26.229 -248.8,78.622 z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    style: {
      fill: "#e10070",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4592.73,4181.95 v -1505 l 1505,-0.07 v 1505.07 l -1505,-0.04 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    style: {
      fill: "#e10070",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 73.1602,7602.42 0.199219,4980.04 392.379,4911.64 c 72.973,770.74 278.211,1345.39 611.141,1719.38 351.17,392.18 830.03,597.42 1450.27,615.66 V 1755.7 c 0,-478.86 -68.4,-788.981 -205.24,-934.919 C 2130,697.66 1924.77,624.652 1641.99,597.301 1559.92,588.16 1413.98,588.16 1213.32,588.16 V 164.02 l 3671.29,4.57 v 419.57 c -200.66,0 -346.6,0 -428.71,9.141 -282.74,27.351 -487.97,100.32 -606.56,223.48 -136.8,145.938 -205.24,456.059 -205.24,934.919 v 5490.98 c 620.28,-18.24 1099.14,-223.48 1450.28,-615.66 332.92,-373.99 533.59,-948.64 611.13,-1719.38 l 392.22,68.4 -72.96,2622.38 -5951.6098,-0.04 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    style: {
      fill: "#e10070",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 1505.2,4181.95 0.199219,4181.91 V 2676.95 L 1505.2,2676.91 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(2.24871)",
    id: "g46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path48",
    style: {
      fill: "#e10070",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16068.8,2161.9 v 265.68 l 50.7,-0.02 66.9,-214.95 62.9,214.97 50.7,-0.02 V 2161.9 l -34.5,-0.01 v 208.9 l -60.8,-208.89 -40.6,-0.01 -60.8,204.85 V 2161.9 l -34.5,-0.01 z m -144,0 v 231.21 l -73,-0.02 v 34.49 l 184.6,-0.02 v -34.45 l -73.1,-0.02 V 2161.9 l -38.5,-0.01 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTMobile);
export default __webpack_public_path__ + "static/media/t-mobile.bf07df8faab3f2fc1a63536dc9880a4a.svg";
export { ForwardRef as ReactComponent };